import { useMemo } from "react";
import { useAppConfig } from "./useAppConfig";
import { useQueryAudits } from "./useQueryAudits";
export const useSundaeAudit = (hash) => {
    const { data: audits, isLoading } = useQueryAudits(hash);
    const config = useAppConfig();
    return useMemo(() => !isLoading && audits
        ? audits.find(({ auditorLabel }) => auditorLabel === config?.proposals?.audits?.defaultAuditor)
        : null, [audits]);
};
//# sourceMappingURL=useSundaeAudit.js.map